(function() {
  var myVar = setInterval(timer, 500);
  function timer() {
    if (window.$) {
      $(document).ready(function() {
        SwellConfig.Link.initializeLinks(".swell-link-redirect");
        SwellConfig.LocalStorage.initializeLocalStorage();
      });  
      stop();
    }
  }
  function stop() {
    clearInterval(myVar);
  }
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    },
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && (window.location.pathname === '/account' || window.location.pathname === '/')) {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);